<template>
  <div class="appBody study-text bg-grey-light">
    <van-nav-bar class="header-exam">
      <template #title>
        <div class="color-33 font-13 w-100 van-ellipsis">{{resultObj.title}}</div>
      </template>
    </van-nav-bar>
    <van-row type="flex" class="bg-white mx-3 mt-4 flex-column radius-all">
      <div class="name-img">
        <div class="u_info d-flex align-items-center">
          <van-image
            class="u_avatar " round :src="userInfo.avatar|getAvator"
          />
          <p class="mb-0 text-white font-14">{{userInfo.name}}</p>
          <p class="mb-0 text-33 font-14 ml-auto">得分：<span class="text-white">{{userLastExam.score|getDian}}分</span></p>
        </div>
      </div>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/defenlv.png"
        />
        得分率
        <span class="ml-auto">{{(scoreRate?scoreRate:0.00)}}%</span>
      </van-col>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/manfen.png"
        />
        满分
        <span class="ml-auto">{{totalScore}}分</span>
      </van-col>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/history.png"
        />
        历史最高分
        <span class="ml-auto">{{maxScore|getDian}}分</span>
      </van-col>
      <van-col class="result-col border-bottom-0 d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/time_used.png"
        />
        用时
        <span class="ml-auto">{{usedTimeStr}}</span>
      </van-col>
    </van-row>

    <div class="pb-4 pt-2" v-if="allQuetion && allQuetion.length>0">
      <div v-for="(item, index) in allQuetion" :key="index">
        <div class="question-list">
          <div class="question-card bg-white radius-all" v-if="item.itemType === 'question'">
            <div class="d-flex align-items-center font-14 color-33 mb-2">
              <div class="bg-base hao text-white">{{item.indexShow|numberFormat}}</div>
              {{item.title}}（{{getTypeTxt(item.type)}}）
            </div>

            <div class="font-12 color-33" :class="{'border-bottom': item.type!=='opening'}">
              <label v-if="item.type==='single' || item.type==='multiple'||item.type==='trueOrFalse'"
                     class="w-100 option mb-3 pl-1"
                     v-for="opt in item.options" :key="opt.id" :id="opt.id"
                     :class="{'bg-base-light': opt.isCheck&&opt.right, 'bg-red-light':opt.isCheck&&!opt.right}">
                <input disabled v-if="item.type==='single'||item.type==='trueOrFalse'"
                       type="radio"
                       :name="item.title" v-model="item.userExamItem.answers[0]" :value="opt.id">

                <input disabled v-if="item.type==='multiple'" type="checkbox"
                       :name="item.title" v-model="item.userExamItem.answers" :value="opt.id">

                {{opt.letter}}.<span class="ml-1">{{opt.title}}</span>
                <van-icon v-if="opt.isCheck&&!opt.right" class="ml-auto pr-2 text-white" name="cross"/>
              </label>
              <van-field disabled class="mt-3 p-0" v-if="item.type==='opening'"
                         v-model="item.userExamItem.answers[0]"
                         rows="2"
                         autosize
                         type="textarea"
              />
            </div>

            <van-row type="flex" class="flex-column mt-2"
                     v-if="item.type==='single' || item.type==='multiple'||item.type==='trueOrFalse'">
              <van-col class="font-12 color-33 mt-2 d-flex align-items-center">
                我的答案：<span :class="{'color-red':!item.userExamItem.correct,'text-primary':item.userExamItem.correct}">{{item.myAnswers && item.myAnswers.length>0?item.myAnswers.join(''):'无'}}</span>
                <span class="font-12 color-red ml-auto"
                      v-if="resultObj.showType && resultObj.showType === 'rightOrWrong' && !item.userExamItem.correct"
                >错误答案</span>
              </van-col>

              <van-col class="font-12 color-33 mt-2" v-if="resultObj.showType && resultObj.showType === 'correctAnswer'
              && item.correctAnswers && item.correctAnswers.length>0">
                正确答案：<span class="text-primary">{{item.correctAnswers.join('')}}</span>
              </van-col>
              <van-col class="d-flex flex-column" v-if="item.answerDesc">
                <span class="font-12 font-weight-600 color-33 answerDesc">答案解析：</span>
                <span class="font-12 color-88 mt-1">{{item.answerDesc}}</span>
              </van-col>

            </van-row>
          </div>
          <div v-else class="font-14 color-33">
            {{item.title}}
          </div>
        </div>
      </div>

    </div>
    <div class="color-99 font-12 text-center pb-5">
      <img class="noMore" src="/static/img/index/no_more.png" alt=""></div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Button, NavBar, Field, Image as VanImage, Icon, Col, Row} from 'vant';
  import Cookies from "js-cookie";
  import {mapState} from "vuex";

  Vue.use(Icon);
  Vue.use(NavBar);
  Vue.use(Button);
  Vue.use(VanImage);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Field);

  export default {
    name: "examAnswer",
    data() {
      return {
        isPass: false,
        resultObj: {},
        userLastExam: {},
        indexShow: 0,
        maxScore: 0,
        totalScore: 0,
        scoreRate: '0',
        examTimes: 0,
        userInfo: {},
        usedTimeStr: '',
        exId: '',
        userEId: '',
        questions: [],
        allQuetion: [],
      }
    },
    computed: {
      ...mapState({
        LetterList: state => state.LetterList
      }),
    },
    mounted() {
      this.exId = this.$route.params['id'];
      this.userEId = this.$route.query['userExamId'];

      let names = window.location.hostname.split(".");
      if (names.length > 2) {
        names[0] = "";
      }
      this.domain = names.join(".");
      if (Cookies.get('anqiu_education_token') && Cookies.get('u_info')) {
        this.userInfo = JSON.parse(Cookies.get('u_info'));
      } else {
        this.userInfo = {};
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});
      }
      this.loadData();
      this.getQuestionsList();
    },
    methods: {
      loadData() {
        this.$store.dispatch('getSessionExamForLearnerUrl', {id: this.exId}).then((res) => {
          if (res) {
            this.resultObj = res;
            this.getExamResult();
          }
        })
      },
      getTypeTxt(type) {
        switch (type) {
          case 'single':
            return '单选';
          case 'multiple':
            return '多选';
          case 'trueOrFalse':
            return '判断';
          case 'opening':
            return '主观';
          default:
            return '';
        }
      },
      getExamResult() {
        if (this.resultObj.userSession && this.resultObj.userSession.userExams && this.resultObj.userSession.userExams.length > 0) {

          if (this.resultObj.userSession && this.resultObj.userSession.userExams) {
            this.examTimes = this.resultObj.userSession.userExams.length
          }
          //最后一次考试成绩
          //历史最高分
          for (let model of this.resultObj.userSession.userExams) {

            if (model.score > this.maxScore) {
              this.maxScore = model.score;
            }
            //从考试页面过来的成绩
            if (this.uExamId && this.uExamId === model.id) {
              this.userLastExam = model;
              //为了遍历历史最高分不能break！！！！！！！！！！！！！
            } else if(!this.uExamId) {
              // 最近的一条为最后一次考试
              this.userLastExam = this.resultObj.userSession.userExams[0];
            }
            // //最后一次交卷的成绩
            // if (model.finished) {
            //   this.userLastExam = model;
            // }
          }
          if (this.userLastExam && this.userLastExam.score && this.resultObj.passmark >= 0) {
            if (this.userLastExam.score >= this.resultObj.passmark) {
              this.isPass = true;
            } else {
              this.isPass = false;
            }
          }

          //满分
          if (this.resultObj.statInfo && this.resultObj.statInfo.totalScore >= 0) {
            this.totalScore = this.resultObj.statInfo.totalScore;
          } else {
            this.totalScore = 0;
          }
          //得分率
          if (this.totalScore > 0) {
            this.scoreRate = ((this.userLastExam.score / this.totalScore) * 100).toFixed(2);
          }
          this.getTime();
        }
      },
      getTimeStr(value) {
        let time = '';
        let leftTime = value;
        let func = function checTime(i) {
          return i < 10 ? "0" + i : i + "";
        };

        let h = parseInt(leftTime / (1000 * 60 * 60) % 24);
        let m = parseInt(leftTime / (1000 * 60) % 60);
        let s = parseInt(leftTime / 1000 % 60);

        let hours = func(h);
        let minutes = func(m);
        let seconds = func(s);

        if (hours > 0) {
          time = hours + ':' + minutes + ':' + seconds;
        } else if (minutes > 0) {
          time = '00:' + minutes + ':' + seconds;
        } else if (seconds > 0) {
          time = '00:' + '00:' + seconds;
        }
        return time;
      },
      getTime() {
        let count = 0;
        let startTime = 0;
        let finishedTime = 0;
        if (this.userLastExam && this.userLastExam.createdTime) {
          startTime = this.userLastExam.createdTime;
        }

        if (this.userLastExam && this.userLastExam.finishedTime) {
          finishedTime = this.userLastExam.finishedTime;
        }
        count = finishedTime - startTime;
        this.usedTimeStr = this.getTimeStr(count);
      },
      getQuestionsList() {
        this.$store.dispatch('getUserExamForLearnerUrl', {examId: this.exId, userExamId: this.userEId}).then((res) => {
          if (res) {
            this.questions = res;
            if (res.questions && res.questions.length > 0) {
              this.allQuetion = res.questions;
              for (let item of this.allQuetion) {
                //去掉题干序号
                if (item.itemType === 'section') {
                  item.indexShow = -1;
                } else {
                  this.indexShow++;
                  item.indexShow = this.indexShow;
                }

                if (item.type &&
                  (item.type === 'single' ||
                    item.type === 'multiple' ||
                    item.type === 'trueOrFalse') &&
                  item.options &&
                  item.options.length > 0) {
                  //单选 多选 判断 添加 A B C D
                  for (let j = 0; j < item.options.length; j++) {
                    if (j >= 26) {
                      break;
                    }
                    item.options[j].letter = this.LetterList[j];
                  }
                  item.myAnswers = item.myAnswers ? item.myAnswers : [];
                  item.correctAnswers = item.correctAnswers ? item.correctAnswers : [];
                  //如果是多选题 则将已选的更新到options里
                  for (let opt of item.options) {
                    opt.isCheck = false;
                    if (item.userExamItem && item.userExamItem.answers && item.userExamItem.answers.length > 0) {
                      for (let ans of item.userExamItem.answers) {
                        if (ans === opt.id) {
                          opt.isCheck = true;
                          item.myAnswers.push(opt.letter);
                          break;
                        }
                      }
                    }
                    if (opt.right) {
                      item.correctAnswers.push(opt.letter);
                    }
                  }
                }
              }
            }
          }
        })
      },
      onClickLeft() {
        this.$router.push('/course/exam/' + this.exId);
      },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .bg-base-light {
    background-color: #2474ff30;
    margin: .5rem 0 !important;
    padding: .5rem 0;
  }

  .bg-red-light {
    background-color: #ff000030;
    margin: .5rem 0 !important;
    padding: .5rem 0;
  }

  .answerDesc {
    margin-top: pxTorem(11px);
  }

  .name-img {
    height: pxTorem(75px);
    background-image: url("/static/img/session/name.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .u_info {
    margin: pxTorem(16px) pxTorem(20px) pxTorem(0px) pxTorem(20px);

    .u_avatar {
      height: pxTorem(32px);
      width: pxTorem(32px);
      margin-right: pxTorem(13px);
    }
  }

  .result-col {
    margin: pxTorem(0px) pxTorem(16px) pxTorem(0px) pxTorem(16px);
    border-bottom: pxTorem(1px) solid #eeeeee;
    height: pxTorem(48px);
  }

  .icon-result {
    width: pxTorem(15px);
    height: pxTorem(15px);
  }

  .question-list {
    margin: pxTorem(26px) pxTorem(20px) pxTorem(0px) pxTorem(20px);
  }

  .noMore {
    height: pxTorem(50px);
  }

  .question-card {
    background-color: white;
    padding: pxTorem(16px) pxTorem(16px) pxTorem(24px) pxTorem(22px);
    min-height: pxTorem(100px);
    box-shadow: 1px 1px 0 1px #9999991c;
    border-radius: 4px;
  }


  .study-text .hao {
    border-radius: pxTorem(8px);
    width: pxTorem(27px);
    height: pxTorem(27px);
    margin-right: pxTorem(14px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .xuhao {
    max-width: 640px;
    margin: 0 auto;
  }

  .study-text .option {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: .5rem;
    cursor: pointer;
  }

  .study-text .option input {
    margin-right: 1.5rem;
    width: 1rem;
    height: 1rem;
    flex: none;
    cursor: pointer;
  }
</style>
